export const fetchWithRetry = async <T>(promiseFn: () => Promise<T>, retries: number = 3): Promise<T> => {
  try {
    return await promiseFn()
  } catch (error) {
    return retries > 0
      ? await fetchWithRetry(promiseFn, retries - 1)
      : await Promise.reject(error)
  }
}

export const jsonPayload = (method: 'put' | 'post', data: object) => ({
  headers: { 'Content-Type': 'application/json' },
  method,
  body: JSON.stringify(data)
})
